import React from 'react';

export const ArrowIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'>
      <path d='M24 24H0V0h24v24z' fill='none' opacity='.87' />
      <path d='M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z' />
    </svg>
  );
};

export const PointerArrowIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M3.5,5.3l6.2,14.7c0.3,0.8,1.5,0.8,1.9,0l2.1-5.3c0.1-0.3,0.3-0.5,0.6-0.6l5.3-2.1c0.8-0.3,0.8-1.5,0-1.9L4.9,3.9
	C4,3.6,3.2,4.4,3.5,5.3z'
      />
    </svg>
  );
};

export const PointerCircleIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M12,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S14.2,8,12,8z M20.9,11c-0.5-4.2-3.8-7.5-7.9-7.9V2c0-0.5-0.4-1-1-1s-1,0.5-1,1
	v1.1C6.8,3.5,3.5,6.8,3.1,11H2c-0.5,0-1,0.4-1,1s0.5,1,1,1h1.1c0.5,4.2,3.8,7.5,7.9,7.9V22c0,0.5,0.4,1,1,1s1-0.5,1-1v-1.1
	c4.2-0.5,7.5-3.8,7.9-7.9H22c0.5,0,1-0.4,1-1s-0.5-1-1-1C22,11,20.9,11,20.9,11z M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7
	S15.9,19,12,19z'
      />
    </svg>
  );
};

export const SolidLineTypeIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path d='M22,13H2c-0.6,0-1-0.4-1-1v0c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1v0C23,12.6,22.6,13,22,13z' />
    </svg>
  );
};

export const LineDotIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path d='M4,11H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S4.6,11,4,11z' />
        <path d='M10,11H8c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S10.6,11,10,11z' />
        <path d='M16,11h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S16.6,11,16,11z' />
        <path d='M22,11h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S22.6,11,22,11z' />
      </g>
    </svg>
  );
};

export const LineDashIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path d='M6,11H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S6.6,11,6,11z' />
        <circle cx='10' cy='12' r='1' />
        <path d='M18,11h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h4c0.6,0,1-0.4,1-1S18.6,11,18,11z' />
        <circle cx='22' cy='12' r='1' />
      </g>
    </svg>
  );
};

export const ToolPointerIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M24,24H0L0,0l24,0V24z' />
      <path
        d='M22.5,5h-2.8l1.6-1.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L19,4.3V1.5C19,1.2,18.8,1,18.5,1S18,1.2,18,1.5v2.8l-1.6-1.6
	c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L17.3,5h-2.8C14.2,5,14,5.2,14,5.5S14.2,6,14.5,6h2.8l-3.6,3.6L12,8c-0.3-0.3-0.8-0.3-1.1,0
	L0.5,18.5c-0.3,0.3-0.3,0.8,0,1.1l4,4c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2L16,13c0.3-0.3,0.3-0.8,0-1.1l-1.6-1.6L18,6.7v2.8
	c0,0.3,0.2,0.5,0.5,0.5S19,9.8,19,9.5V6.7l1.6,1.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L19.7,6h2.8
	C22.8,6,23,5.8,23,5.5S22.8,5,22.5,5z M5,21.9L2.1,19l2.4-2.4l2.9,3L5,21.9z M8.9,15.9l-0.7-0.7l1.5-1.5l0.7,0.7L8.9,15.9z
	 M13.5,13.4l-2.9-2.9l0.9-0.9l2.9,2.9L13.5,13.4z'
      />
    </svg>
  );
};

export const ToolUndoIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='black'
      width='24px'
      height='24px'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M12.5 8c-2.65 0-5.05.99-6.9 2.6L3.71 8.71C3.08 8.08 2 8.52 2 9.41V15c0 .55.45 1 1 1h5.59c.89 0 1.34-1.08.71-1.71l-1.91-1.91c1.39-1.16 3.16-1.88 5.12-1.88 3.16 0 5.89 1.84 7.19 4.5.27.56.91.84 1.5.64.71-.23 1.07-1.04.75-1.72C20.23 10.42 16.65 8 12.5 8z' />
    </svg>
  );
};

export const ToolRedoIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='black'
      width='24px'
      height='24px'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.16 0-7.74 2.42-9.44 5.93-.32.67.04 1.47.75 1.71.59.2 1.23-.08 1.5-.64 1.3-2.66 4.03-4.5 7.19-4.5 1.95 0 3.73.72 5.12 1.88l-1.91 1.91c-.63.63-.19 1.71.7 1.71H21c.55 0 1-.45 1-1V9.41c0-.89-1.08-1.34-1.71-.71l-1.89 1.9z' />
    </svg>
  );
};

export const ToolSelectIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M17.8,14.4L8,3.2C7.9,3,7.6,2.9,7.4,3C7.2,3.1,7,3.4,7,3.6v14.8c0,0.3,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0
	c0.2,0,0.4-0.1,0.5-0.3l2.6-3.4l2.2,5.8C13,21.7,13.5,22,14,22c0.2,0,0.3,0,0.5-0.1c0.7-0.3,1-1,0.8-1.7l-0.4-1l-1.7-4.7l4.1,0.8
	c0.3,0.1,0.5-0.1,0.6-0.3C18.1,14.9,18,14.6,17.8,14.4z'
      />
    </svg>
  );
};

export const ToolFontIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='black'
      width='24px'
      height='24px'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M23 6V2c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H7V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h1v10H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1h10v1c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-1V7h1c.55 0 1-.45 1-1zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-1c0-.55-.45-1-1-1H5V7h1c.55 0 1-.45 1-1V5h10v1c0 .55.45 1 1 1h1v10h-1c-.55 0-1 .45-1 1v1zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-6.06 2.65c-.15-.39-.53-.65-.95-.65-.42 0-.8.26-.94.65l-2.77 7.33c-.19.49.17 1.02.7 1.02.32 0 .6-.2.71-.5l.55-1.5h3.49l.56 1.51c.11.29.39.49.71.49h.01c.53 0 .89-.53.71-1.02l-2.78-7.33zm-2.25 5.09L12 8.91l1.3 3.83h-2.61z' />
    </svg>
  );
};

export const ToolImageIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='black'
      width='24px'
      height='24px'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 15.92c-.02.03-.06.06-.08.08H3V5.08L3.08 5h17.83c.03.02.06.06.08.08v13.84zm-10-3.41L8.5 12.5 5 17h14l-4.5-6z' />
    </svg>
  );
};

export const ToolPartsIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M24,24H0L0,0l24,0V24z' />
      <g>
        <g>
          <path
            d='M19,7h-4.2c-0.4,0-0.7,0.2-0.9,0.5l-2.8,5C11,12.7,11,12.8,11,13h0v1c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1v-1v-3
			C22,8.3,20.7,7,19,7z M15.4,9H18v3h-4.3L15.4,9z'
          />
        </g>
        <path
          d='M20,16h-8c-1.7,0-3,1.3-3,3s1.3,3,3,3h8c1.7,0,3-1.3,3-3S21.7,16,20,16z M12,20.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5
		s1.5,0.7,1.5,1.5S12.8,20.5,12,20.5z M20,20.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S20.8,20.5,20,20.5z'
        />
        <path
          d='M12.6,7.2l-6.7-7C5.8,0.1,5.6,0,5.5,0h-2C3.3,0,3.1,0.1,3.1,0.3C3,0.4,3,0.6,3.1,0.7C3,0.8,3,0.9,3,1v7C2.4,8,2,8.4,2,9v1
		c0,0.5,0.3,0.8,0.8,0.9v0.5c-0.9,0.4-2,1.2-2,2.5c0,1.7,1.4,2.6,2.8,2.6s2.8-0.9,2.8-2.6c0-0.4-0.3-0.8-0.8-0.8S4.8,13.6,4.8,14
		c0,1.1-1.1,1.1-1.2,1.1s-1.2,0-1.2-1.1c0-0.9,1.4-1.3,1.4-1.3C4,12.6,4.2,12.3,4.2,12v-1.1C4.7,10.8,5,10.5,5,10V9c0-0.6-0.4-1-1-1
		V2.1l6.1,8.7c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0,0,0,0c0.2,0,0.3-0.1,0.4-0.3l1.7-3C12.7,7.6,12.7,7.3,12.6,7.2z'
        />
      </g>
    </svg>
  );
};

export const ToolShapeIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      style={{ enableBackground: 'new 0 0 24 24' }}
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path d='M15,8c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S18.9,8,15,8z M15,20c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S17.8,20,15,20z' />
        <polygon points='4,4 14,4 14,7 16,7 16,2 2,2 2,16 7,16 7,14 4,14 	' />
      </g>
    </svg>
  );
};

export const ToolShapeCircleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 -2 24 24'
      width='20'
      height='20'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
    </svg>
  );
};

export const ToolShapeSquareIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 -2 24 24'
      style={{ enableBackground: 'new 0 -2 24 24' }}
      xmlSpace='preserve'
      width='20'
      height='20'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path d='M21,3H3v18h18V3z M19,19H5V5h14V19z' />
    </svg>
  );
};

export const ToolShapePolygonIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 -2 24 24'
      style={{ enableBackground: 'new 0 -2 24 24' }}
      xmlSpace='preserve'
      width='20'
      height='20'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path d='M12,4.5l8.1,5.9L17,19.9h-10l-3.1-9.5L12,4.5 M12,2L1.5,9.6l4,12.3h12.9l4-12.3L12,2L12,2z' />
    </svg>
  );
};

export const ToolShapeSectorIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 21'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.63173 10.5104L0.560661 17.5815C0.986444 18.0073 1.44107 18.3866 1.91825 18.7196C5.81772 21.4403 11.2233 21.0609 14.7028 17.5815C18.608 13.6762 18.608 7.34458 14.7028 3.43934C11.2233 -0.0401213 5.81772 -0.419482 1.91825 2.30126C1.44107 2.63419 0.986444 3.01356 0.560661 3.43934L7.63173 10.5104ZM3.19034 3.57335L10.1274 10.5104L3.19034 17.4475C6.37802 19.4927 10.6672 19.1214 13.455 16.3336C16.671 13.1176 16.671 7.90326 13.455 4.68717C10.6672 1.89941 6.37802 1.52813 3.19034 3.57335Z'
      />
    </svg>
  );
};

export const ToolLineIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path d='M4,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l16-16c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-16,16C4.5,20.9,4.3,21,4,21z' />
    </svg>
  );
};

export const ToolLineNormalIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path d='M4,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l16-16c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-16,16C4.5,20.9,4.3,21,4,21z' />
    </svg>
  );
};

export const ToolLinePolylineIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M4,21c-0.1,0-0.2,0-0.3,0c-0.5-0.2-0.8-0.7-0.7-1.3l5-16C8.2,3.3,8.5,3,8.9,3c0.4,0,0.8,0.2,1,0.6L15,15.4l4.1-9.8
	c0.2-0.5,0.8-0.7,1.3-0.5c0.5,0.2,0.8,0.8,0.5,1.3l-5,12C15.8,18.8,15.4,19,15,19c-0.4,0-0.8-0.2-0.9-0.6L9.1,6.9L5,20.3
	C4.8,20.7,4.4,21,4,21z'
      />
    </svg>
  );
};

export const ToolLineFreeHandIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M11.1,21c-0.4,0-0.8,0-1.2-0.1c-2.8-0.4-4.3-2.5-4.1-5.5c0.2-2.5,1.8-5.7,4.4-7.9C8.5,6.1,6.4,5,4,5C3.4,5,3,4.5,3,4
	s0.4-1,1-1c3.1,0,5.8,1.5,7.7,3.4C13.3,5.5,15,5,17,5c3.7,0,4.9,4.5,5,4.7c0.1,0.5-0.2,1.1-0.7,1.2c-0.5,0.1-1.1-0.2-1.2-0.7
	c0,0-0.9-3.2-3-3.2c-1.4,0-2.7,0.4-3.9,1c0.6,0.8,1.1,1.6,1.5,2.4c1.8,3.4,2,6.8,0.5,8.8C14.5,20,13.3,21,11.1,21z M11.4,9.1
	c-2.2,1.8-3.6,4.4-3.7,6.5c-0.1,1.4,0.2,3,2.4,3.3c1.6,0.2,2.8-0.1,3.4-1c1-1.4,0.7-4.1-0.7-6.7C12.5,10.5,12,9.8,11.4,9.1z'
      />
    </svg>
  );
};

export const ToolCopyCanvasIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='black'
      width='24px'
      height='24px'
    >
      <path d='M0 0h24v24H0V0zm0 0h24v24H0V0z' fill='none' />
      <path d='M12.35 15.65l2.79-2.79c.31-.31.09-.85-.35-.85H13V4c0-.55-.45-1-1-1s-1 .45-1 1v8H9.21c-.45 0-.67.54-.35.85l2.79 2.79c.19.2.51.2.7.01zM21 3h-5.01c-.54 0-.99.45-.99.99 0 .55.45.99.99.99H20c.55 0 1 .45 1 1v12.03c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h4.01c.54 0 .99-.45.99-.99 0-.55-.45-1-.99-1H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' />
    </svg>
  );
};

export const ToolPanIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M21.8,11.6l-2.9-3C18.6,8.3,18,8.6,18,9v1.9h0V11h-5V6h0.1v0H15c0.5,0,0.7-0.6,0.4-0.9l-3-2.9c-0.2-0.2-0.5-0.2-0.8,0
	l-3,2.9C8.3,5.4,8.6,6,9,6h1.9v0H11v5H6v-0.1h0V9c0-0.5-0.6-0.7-0.9-0.4l-2.9,3c-0.2,0.2-0.2,0.5,0,0.8l2.9,3C5.4,15.7,6,15.4,6,15
	v-1.9h0V13h5v5h-0.1v0H9c-0.5,0-0.7,0.6-0.4,0.9l3,2.9c0.2,0.2,0.5,0.2,0.8,0l3-2.9c0.3-0.3,0.1-0.9-0.4-0.9h-1.9v0H13v-5h5v0.1h0
	V15c0,0.5,0.6,0.7,0.9,0.4l2.9-3C22.1,12.2,22.1,11.8,21.8,11.6z'
      />
    </svg>
  );
};

export const ToolBackgroundIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path d='M10,20H5c-0.5,0-1-0.5-1-1v-5c0-0.5-0.5-1-1-1s-1,0.5-1,1v6c0,1.1,0.9,2,2,2h6c0.5,0,1-0.5,1-1S10.5,20,10,20z' />
        <path d='M3,11c0.5,0,1-0.5,1-1V5c0-0.5,0.5-1,1-1h5c0.5,0,1-0.5,1-1s-0.5-1-1-1H4C2.9,2,2,2.9,2,4v6C2,10.5,2.5,11,3,11z' />
        <path
          d='M9.6,13.5l-3,3.7C6.4,17.5,6.6,18,7,18h10c0.4,0,0.7-0.5,0.4-0.8l-2-2.7c-0.2-0.3-0.6-0.3-0.8,0L13,16.7l-2.6-3.2
		C10.2,13.2,9.8,13.2,9.6,13.5z'
        />
        <path d='M21,13c-0.5,0-1,0.5-1,1v5c0,0.5-0.5,1-1,1h-5c-0.5,0-1,0.5-1,1s0.5,1,1,1h6c1.1,0,2-0.9,2-2v-6C22,13.5,21.5,13,21,13z' />
        <path
          d='M21.8,6.5c0-0.2,0-0.3,0-0.5s0-0.3,0-0.5l1.1-0.8C23,4.6,23,4.5,23,4.4l-1-1.7c-0.1-0.1-0.2-0.2-0.3-0.1L20.3,3
		c-0.3-0.2-0.6-0.4-0.9-0.5l-0.2-1.3C19.2,1.1,19.1,1,19,1h-2c-0.1,0-0.2,0.1-0.3,0.2l-0.2,1.3c-0.3,0.1-0.6,0.3-0.9,0.5l-1.3-0.5
		c-0.1,0-0.2,0-0.3,0.1l-1,1.7c-0.1,0.1,0,0.2,0.1,0.3l1.1,0.8c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0,0.5l-1.1,0.8C13,7.4,13,7.5,13,7.6
		l1,1.7c0.1,0.1,0.2,0.2,0.3,0.1l1.3-0.5c0.3,0.2,0.6,0.4,0.9,0.5l0.2,1.3c0,0.1,0.1,0.2,0.3,0.2h2c0.1,0,0.2-0.1,0.3-0.2l0.2-1.3
		c0.3-0.1,0.6-0.3,0.9-0.5l1.3,0.5c0.1,0,0.2,0,0.3-0.1l1-1.7c0-0.1,0-0.2-0.1-0.3L21.8,6.5z M18,7.5c-0.8,0-1.5-0.7-1.5-1.5
		s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S18.8,7.5,18,7.5z'
        />
      </g>
    </svg>
  );
};

export const ToolCutIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      height='24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M9.64 7.64c.29-.62.42-1.33.34-2.09-.19-1.73-1.54-3.2-3.26-3.49-2.77-.48-5.14 1.89-4.66 4.65.3 1.72 1.76 3.07 3.49 3.26.76.08 1.46-.05 2.09-.34L10 12l-2.36 2.36c-.62-.29-1.33-.42-2.09-.34-1.73.19-3.2 1.54-3.49 3.26-.48 2.77 1.89 5.13 4.65 4.65 1.72-.3 3.07-1.76 3.26-3.49.08-.76-.05-1.46-.34-2.09L12 14l7.59 7.59c.89.89 2.41.26 2.41-1v-.01c0-.37-.15-.73-.41-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm7.59-10.09L13 9l2 2 6.59-6.59c.26-.26.41-.62.41-1V3.4c0-1.25-1.52-1.88-2.41-.99z' />
    </svg>
  );
};

export const ToolCopyIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M15 1H4c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm4 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z' />
    </svg>
  );
};

export const ToolPasteIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 18H6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h1v1c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V4h1c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1z' />
    </svg>
  );
};

export const ToolPrintRangeIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path
          d='M22,1h-4c-0.5,0-1,0.5-1,1v1H7V2c0-0.5-0.5-1-1-1H2C1.5,1,1,1.5,1,2v4c0,0.5,0.5,1,1,1h1v10H2c-0.5,0-1,0.5-1,1v4
		c0,0.5,0.5,1,1,1h4c0.5,0,1-0.5,1-1v-1h1c0.6,0,1-0.4,1-1s-0.4-1-1-1H7v-1c0-0.5-0.5-1-1-1H5V7h1c0.5,0,1-0.5,1-1V5h10v1
		c0,0.5,0.5,1,1,1h1v1c0,0.6,0.4,1,1,1s1-0.4,1-1V7h1c0.5,0,1-0.5,1-1V2C23,1.5,22.5,1,22,1z M5,21H3v-2h2V21z M5,5H3V3h2V5z M21,5
		h-2V3h2V5z'
        />
        <path
          d='M22,14H12c-1.1,0-2,0.9-2,2v3c0,0.6,0.4,1,1,1h1.5v-4h9v4H23c0.6,0,1-0.4,1-1v-3C24,14.9,23.1,14,22,14z M23,17h-1v-1h1V17
		z'
        />
        <path d='M20,18v3h-6v-3H20 M22,16H12v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V16L22,16z' />
        <g>
          <path d='M21.5,13h-9c-0.3,0-0.5-0.2-0.5-0.5V11c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v1.5C22,12.8,21.8,13,21.5,13z' />
        </g>
      </g>
    </svg>
  );
};

export const ToolPrintCanvasIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M19 8H5c-1.66 0-3 1.34-3 3v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h2c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm-4 11H9c-.55 0-1-.45-1-1v-4h8v4c0 .55-.45 1-1 1zm4-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-9H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' />
    </svg>
  );
};

export const ToolGroupIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <g>
        <path
          d='M22,7c0.5,0,1-0.5,1-1V2c0-0.5-0.5-1-1-1h-4c-0.5,0-1,0.5-1,1v1H7V2c0-0.5-0.5-1-1-1H2C1.5,1,1,1.5,1,2v4c0,0.5,0.5,1,1,1
		h1v10H2c-0.5,0-1,0.5-1,1v4c0,0.5,0.5,1,1,1h4c0.5,0,1-0.5,1-1v-1h10v1c0,0.5,0.5,1,1,1h4c0.5,0,1-0.5,1-1v-4c0-0.5-0.5-1-1-1h-1V7
		H22z M3,3h2v2H3V3z M5,21H3v-2h2V21z M17,18v1H7v-1c0-0.5-0.5-1-1-1H5V7h1c0.5,0,1-0.5,1-1V5h10v1c0,0.5,0.5,1,1,1h1v10h-1
		C17.5,17,17,17.5,17,18z M21,21h-2v-2h2V21z M19,5V3h2v2H19z'
        />
        <path
          d='M17,10h-3V8c0-0.6-0.4-1-1-1H7C6.4,7,6,7.4,6,8v5c0,0.6,0.4,1,1,1h3v2c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1v-5
		C18,10.4,17.6,10,17,10z M8,12V9h4v3H8z M16,15h-4v-1h1c0.6,0,1-0.4,1-1v-1h2V15z'
        />
      </g>
    </svg>
  );
};

export const ToolUnGroupIcon = () => {
  return (
    <svg
      version='1.1'
      id='レイヤー_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
      xmlSpace='preserve'
    >
      <path className='st0' d='M0,0h24v24H0V0z' />
      <path
        d='M23,11V8c0-0.6-0.4-1-1-1h-3c-0.6,0-1,0.4-1,1h-2V7c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1h-3c-0.6,0-1,0.4-1,1H6
	c0-0.6-0.4-1-1-1H2C1.4,2,1,2.4,1,3v3c0,0.6,0.4,1,1,1v5c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1h2v1
	c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1h6c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1v-3c0-0.6-0.4-1-1-1v-5
	C22.6,12,23,11.6,23,11z M14,4h1v1h-1V4z M15,14v1h-1v-1H15z M3,4h1v1H3V4z M4,15H3v-1h1V15z M6,14v-1c0-0.6-0.4-1-1-1H4V7h1
	c0.6,0,1-0.4,1-1V5h6v1c0,0.6,0.4,1,1,1h1v5h-1c-0.6,0-1,0.4-1,1v1H6z M10,20H9v-1h1V20z M18,18v1h-6v-1c0-0.6-0.4-1-1-1h-1v-1h2
	c0,0.6,0.4,1,1,1h3c0.6,0,1-0.4,1-1v-3c0-0.6-0.4-1-1-1v-2h2v1c0,0.6,0.4,1,1,1h1v5h-1C18.4,17,18,17.4,18,18z M21,20h-1v-1h1V20z
	 M21,10h-1V9h1V10z'
      />
    </svg>
  );
};

export const ToolMoveFrontIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 12h-8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-7 6h2v-2h-2v2zm-4 0h2v-2H7v2z' />
    </svg>
  );
};

export const ToolMoveBackIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM4 7c-.55 0-1 .45-1 1v11c0 1.1.9 2 2 2h11c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1V8c0-.55-.45-1-1-1zm11-2h2V3h-2v2zm0 12h2v-2h-2v2z' />
    </svg>
  );
};

export const ToolLockIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <g fill='none'>
        <path d='M0 0h24v24H0V0z' />
        <path d='M0 0h24v24H0V0z' opacity='.87' />
      </g>
      <path d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z' />
    </svg>
  );
};

export const ToolUnLockIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-5h-1V6c0-2.76-2.24-5-5-5-2.28 0-4.27 1.54-4.84 3.75-.14.54.18 1.08.72 1.22.53.14 1.08-.18 1.22-.72C9.44 3.93 10.63 3 12 3c1.65 0 3 1.35 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 11c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v8z' />
    </svg>
  );
};

export const ToolDeleteIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z' />
    </svg>
  );
};

export const ToolInfoIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z' />
    </svg>
  );
};

export const ToolMultiScreenIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H5c-.55 0-1-.45-1-1v-3h4v4zm0-6H4v-4h4v4zm0-6H4V5c0-.55.45-1 1-1h3v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm5 12h-3v-4h4v3c0 .55-.45 1-1 1zm1-6h-4v-4h4v4zm0-6h-4V4h3c.55 0 1 .45 1 1v3z' />
    </svg>
  );
};

export const ToolNextIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M24 24H0V0h24v24z' fill='none' opacity='.87' />
      <path d='M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31c.39-.39.39-1.02 0-1.41L9.15 2.98c-.49-.49-1.28-.49-1.77 0s-.49 1.28 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76z' />
    </svg>
  );
};

export const ToolPrevIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' opacity='.87' />
      <path d='M16.62 2.99c-.49-.49-1.28-.49-1.77 0L6.54 11.3c-.39.39-.39 1.02 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76z' />
    </svg>
  );
};

export const ToolZoomDownIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z' />
    </svg>
  );
};

export const ToolZoomUpIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 0 24 24'
      width='24'
    >
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z' />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/canvas/icon/LayoutIcon.jsx